






























































































































































































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { AuthModule } from '@/store/Auth/AuthModule';
import AppConsts from '@/lib/appConstants';
import InstitutionThemeEdit from '@/components/Settings/Institutions/Theme/InstitutionThemeEdit.vue';

@Component({ name: 'InstitutionTheme', components: { InstitutionThemeEdit } })
export default class extends SaascadaVue {

    AppConsts = AppConsts;

    get institution() {
        return AuthModule.me.institution;
    }

}
